import { Component, ViewChild, Input, OnInit } from "@angular/core";
import { AuthorizationPipe } from "../../common/pipes/authorization.pipe";
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { CustomerService } from "../services/customer.service";
import { ProfileInformation } from "../interface/profile-info";
import { DatePipe } from "@angular/common";
import { CacheService } from "../../shared/services/cache.service";
import { CacheKey } from "../../shared/constants/cachekey.constants";
import { CommonService } from "../../shared/services/common.service";
import { DistributorInfo } from "../interface/ticketingsystem/distributor-info";
import { DistributorIdFormatPipe } from "../../common/pipes/distributor-id-format.pipe";
import { Modal } from "ngx-modal";
import { TranslateService } from "@ngx-translate/core";
import { FileItem, ParsedResponseHeaders, FileUploader } from "ng2-file-upload";
import { saveAs  as  importedSaveAs }  from  "file-saver";
import { PaginationInstance } from 'ngx-pagination';
import { NgProgress } from "ngx-progressbar";
import { UserInfo } from "../../shared/interface/user-info.interface";
import { environment } from "../../../environments/environment";
import { MemberNoteType } from '../common/constants';
import { MemberAttachmentType } from '../common/constants';
import { Permission } from "../../common/enums/permission.enum";
import * as moment from 'moment';
import { OrderService } from "../services/order.service";
import { StoreConfig } from "../../shared/interface/StoreConfig.interface";
import { CommonConstant } from "../../shared/constants/common.constants";
import { ActivityLogKey } from "../interface/activityLogKey";
import { MemberActivityLogType } from "../../shared/common/enumerations";
import { AccessLevel } from "../../common/enums/access-level.enum";
import { CustomValidators } from "../../shared/Utils/custom-validator";
import { NotificationType } from '../enums/notification-types.enum';
import { MemberTypeEnum } from "../enums/member-type.enum";

@Component({
    selector: "member-notes",
    templateUrl: "../templates/template1/views/member-notes.component.html",
    styleUrls: [
        "../templates/template1/themes/default/css/profile-info.less"
    ],
    providers: [AuthorizationPipe, CustomerService, DatePipe, DistributorIdFormatPipe]
})


export class MemberNotesComponent implements OnInit {

    @Input() distributorInfo: DistributorInfo;
    @ViewChild('createAttachmentsModal') createAttachmentsPopup: Modal;
    @ViewChild('createNotesModal') createNotesPopup: Modal;
    @ViewChild('deleteAttachmentsModal') deleteAttachmentsPopUp: Modal;

    @Input() inputid: string;
    @Input() fboid: string;
    @Input() memberType: string;
    fboProfileDetail: ProfileInformation;
    _id: string; // stores fbo id
    showDocument: boolean = false;
    attchmentType: number = MemberAttachmentType.AttachmentTypeID;
    pageNumber: number = 1;
    pageSize: number = 10;
    pageCount: number = 0;
    files: any[];
    fileName: string;
    id: any;
    attachments:any[];
    uploadResponse: any = [];
    uploader: FileUploader;
    userId: number;
    userInfo: UserInfo;
    isDesc: boolean = false;
    attachmentsLength: number;
    createNotesForm: FormGroup;
    isSubmitted:boolean;
    memberNoteTypes:any=[];
    accountLookUpId:number = MemberNoteType.AccountTypeID;
    orderLookUpId:number = MemberNoteType.OrdersTypeID;
    AccountStatusChangeLookUpId:number = MemberNoteType.AccountStatusChangeTypeID;
    memberNotesPageNumber:number =1;
    memberNotesPageCount:number = 0;
    memberNotesSortOrder: boolean = false;
    memberID:string;
    memberNotesInfo:any = [];
    sortOrder:string="createdDate";
    createdDate:string;
    deleteAttachmentId:number;
    attachmentDeleteName:string;
    elementoffsetValue:number;
    attachedFileNames:string;
    isCreateNoteFromAttachmnetsInfo:boolean = false;
    FBODetailPermissions: Permission[] = [Permission.MEMBER_NOTES_CREATE];
    memberId: Number;
    customerServiceAccessLevelId: number= AccessLevel.Customer_Service;
    public paginationInstance: PaginationInstance = {
        id: 'memberAttachments-pagination',
        itemsPerPage: 10,
        currentPage: 1
    };
    storeInfo:StoreConfig;

     public paginationInstance1: PaginationInstance = {
        id: 'memberNotes-pagination',
        itemsPerPage: 10,
        currentPage: 1
    };
    memberTypeEnum = MemberTypeEnum;
    enableFileUploadToPrivate: Boolean = environment.enableFileUploadToPrivate;

    constructor(private _customerservice: CustomerService
        , private _commonService: CommonService
        , private _customerService: CustomerService
        , private _cacheService: CacheService
        , private _translatePipe: TranslateService ,
         private ngProgress: NgProgress,
        private _orderService: OrderService,
        private _formbuilder: FormBuilder) {
    }

    ngOnInit(): void {
        this.memberID = this.inputid;
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this._id = this.fboid;
        this.uploader = this._customerService.getFileUploader();
        this.uploader.onErrorItem = (item: any, response: any, status: any, headers: any) => this.onErrorItem(item, response, status, headers);
        this.uploader.onSuccessItem = (item: any, response: any, status: any, headers: any) => this.onSuccessItem(item, response, status, headers);
        this.userId = this._cacheService.get(CacheKey.UserId);
        this.fboProfileDetail = new ProfileInformation();
        this.memberId =  this.distributorInfo && this.distributorInfo.memberId > 0 ? this.distributorInfo.memberId : (this.fboProfileDetail && this.fboProfileDetail.id > 0 ? this.fboProfileDetail.id : null);
        this.getAttachments();
        this.getStoreConfig();
        this.buildNotesForm();
        if (!this.memberId) {
            this.getMemberInfo();
        }
     }

     /**
      * To get Member Information based on Fbo Id
      *
      */
     getMemberInfo(): void {
        this._customerservice.getMemberInformationFromTitan(this.fboid).subscribe(response => {
            if (response && response.isSuccess) {
                this.memberId = response.memberId;
                this.getStoreConfig();
            }
        });
     }

    getStoreConfig(): void {
        this._orderService.getStoreInfo(CommonConstant.Default_Country).subscribe(response => {
            if (response) {
                this.storeInfo = response;
                this.getMemberNotes();
            }
        });
    }

        buildNotesForm() {
            this.createNotesForm = this._formbuilder.group({
                notesType: ['', Validators.required],
                notesSummary: ['', [Validators.required, CustomValidators.requiredNotEmpty]],
                notesDescription: ['', [Validators.required, CustomValidators.requiredNotEmpty]]
            });
        if(this.memberNoteTypes.length === 0){
            let accountType ={
            "LookupID": this.accountLookUpId,
            "ConfigKey": MemberNoteType.ACCOUNT
            }
            this.memberNoteTypes.push(accountType);
            let orderType ={
                "LookupID": this.orderLookUpId,
                "ConfigKey": MemberNoteType.ORDERS
            }
            this.memberNoteTypes.push(orderType);
        }

        this.memberNotesPageNumber = 1;
        this.memberNotesSortOrder = false;
        this.sortOrder="createdDate";
    }

    openCreateNotesModal() {
        this.buildNotesForm();
        // this._commonService.jumpingScroll(true);
        this.createNotesPopup.open();
        setTimeout(function () {
            const element = document.getElementById("notesType");
            if (element) {
                element.focus();
            }
            //deafultfocus ? this.renderer.invokeElementMethod(this.createNotesInput.nativeElement, 'focus') : '';
        }, 200);

    }
    openDeleteAttachmentPopUp(item:any){
        this.deleteAttachmentId = item.id;
        this.attachmentDeleteName=item.attachmentName;
        this.deleteAttachmentsPopUp.open();
        setTimeout(function () {
            const element = document.getElementById("deleteAttachments");
            if (element) {
                element.focus();
            }
            //deafultfocus ? this.renderer.invokeElementMethod(this.createNotesInput.nativeElement, 'focus') : '';
        }, 200);
    }
    closeDeleteAttachmentPopUp(){
        this.deleteAttachmentsPopUp.close();
    }


    openCreateAttachmentsModal() {
        this.createAttachmentsPopup.open();
        this.count =0;
        this.uploadResponse =[];
    }
    closePopUp() {
        // this._commonService.jumpingScroll(false);
        this.createNotesPopup.close();
    }
/**
* failed to upload file
* @param item
* @param response
* @param status
* @param headers
*/
onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    this.ngProgress.done();
    let error = JSON.parse(response); //error server response
    this._commonService.createNotification("", "Failed to upload document. Please try after sometime ", NotificationType.ERROR);
}

/**
     * On Successful upload of file
     * @param item
     * @param response
     * @param status
     * @param headers
     */
count: number = 0;
onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    if (response) {
        let res = JSON.parse(response);
        let fileData = res.fileName.split('.');
        let attachmentsInfo ={
            "attachmentTypeId": this.attchmentType,
            "attachmentName": res.fileName,
            "note": "",
            "url": res.url
        }
        JSON.stringify(attachmentsInfo);
        this.uploadResponse.push(attachmentsInfo);
        this.count++;
        if (this.uploader.queue.length === this.count) {
             this.saveMemberAttachments();
            //this._commonService.createNotification("", "File Uploaded Successfully", "success");
             this.createAttachmentsPopup.close();
        }

    }

}

/*
 * deleting the attachment
*/
deleteAttachments() {
    if(this.deleteAttachmentId !==undefined && this.deleteAttachmentId!== null){
    this._customerservice.deleteAttachmentsAtMemberLevel(this.deleteAttachmentId, this.userId).subscribe(response => {
        if (response.isSuccess) {
            let responseInfo = response;
            let deleteNotification: any = this._translatePipe.get("Attachment has been deleted succesfully");
            this._commonService.createNotification("", deleteNotification.value, NotificationType.SUCCESS);
            this.getAttachments();
            const activityLogKeys: ActivityLogKey[] = [{
                key: MemberActivityLogType.Attachment,
                value: this.attachmentDeleteName + ' was deleted'
              }];
            if (this.memberId) {
                this._commonService.saveMemberActivity(this.memberId, activityLogKeys).subscribe();
            }
            this.isCreateNoteFromAttachmnetsInfo = true;
            this.deleteAttachmentsPopUp.close();
        }
        else{
            this._commonService.createNotification("", "Attachment Not deleted", NotificationType.ERROR);
        }
    });
}
}

 /** *  UPLOAD FILE   ----- BEGIN ----- ************************* */
/**
 * Upload file
 */
uploadFile() {
    if (this.uploader && this.uploader.queue.length > 0) {
        this.ngProgress.start();
        let filelength = 0;
        this.uploader.onBuildItemForm = (item: any, form: any) => {
            filelength++;
            item.withCredentials = false;
            item.uploader.authToken = this._customerService.getAuthorizationToken();
            const uploadedFileName =item.file.name.split(".");
            const generateFileName = uploadedFileName[0] + '_' + this.memberId + '_' + filelength +'.' + uploadedFileName[uploadedFileName.length-1];
            form.append('fileName', decodeURIComponent(encodeURIComponent(generateFileName)));
            form.append('path', 'content/customer-service/' + this._id + '/');
        };
        for (let i = 0; i < this.uploader.queue.length; i++) {
            this.uploader.queue[i].upload();
        }
    }
}
saveAttachments() {
     this.uploadFile();
}
saveMemberAttachments(){
     let fileDetails = {
        "distributorId": this._id,
        "memberId": this.fboProfileDetail.id?this.fboProfileDetail.id:null,
        "createdByUserId": this.userInfo.userId,
        "createdByUserName": this.userInfo.userName,
        "createdDate": new Date(),
        "memberAttachments": this.uploadResponse
    }

    let attachmentsInfo = fileDetails;
    if (this.uploadResponse.length > 0) {
        let memberNoteDescription: string[] = [];
        this.uploadResponse.forEach(item => {
            memberNoteDescription.push(item.attachmentName);
        });
        this.attachedFileNames = memberNoteDescription.map(function (elem) { return elem; }).join(", ");
    }

    this._customerservice.saveAttachmentsAtMemberLevel(attachmentsInfo).subscribe(response => {
        if (response.isSuccess) {
            let res = response;
            let addedNotification: any = this._translatePipe.get("Attachments  has been Created successfully");
            this._commonService.createNotification("", addedNotification.value, NotificationType.SUCCESS);
            const activityLogKeys: ActivityLogKey[] = [{
                key: MemberActivityLogType.Attachment,
                value: this.attachedFileNames + ' Added'
              }];
            if (this.memberId) {
                this._commonService.saveMemberActivity(this.memberId, activityLogKeys).subscribe();
            }
            this.isCreateNoteFromAttachmnetsInfo  = true;
            this.uploader.queue = [];
        }
        else {
            this._commonService.createNotification("", "File Not uploaded", NotificationType.ERROR);
        }
        this.ngProgress.done();
        this.getAttachments();
    });
}

closeAttachmentPopUp() {
    this.uploader.queue = [];
    this.uploadResponse = [];
    this.createAttachmentsPopup.close();
}

/*
 * Get Member Attachments Info based on MemberID or DistributorID
 */
getAttachments() {
    if(this._id){
        this.fboProfileDetail.id;
        let fileDetails = {
            "memberId":this.fboProfileDetail.id?this.fboProfileDetail.id:null,
            "distributorId": this._id,
            "typeId": this.attchmentType,
            "pageSize": this.pageSize,
            "pageNumber": this.pageNumber,
            "sort": this.isDesc ? "ASC" : "DESC"
        }
        this._customerservice.getAttachmentsAtMemberLevel(fileDetails).subscribe(response => {
            if (response) {
                this.files = response.content;
                this.pageNumber = response.pageNumber + 1;
                this.pageCount = response.totalCount;
            }
            else {
                this.files = [];
                this.pageCount = 0;
            }
        });
    }
}
/*
   *Empty Method
*/
noAction() {
}



/*
 * for downloading the attachment
*/
  downloadDocument(url: string, fileName: string) {
    if (this.enableFileUploadToPrivate) {
      let path = new URL(url).pathname.slice(1);
      let s3Path = path.slice(0, path.lastIndexOf("/") + 1);
      this._customerService.downloadFile(s3Path, fileName).subscribe(blob => {
        this.saveFile(blob,fileName);
      }, err => {
        let downloadNotification: any = this._translatePipe.get("Something Went Wrong, Please try again after some time");
        this._commonService.createNotification("", downloadNotification.value, NotificationType.ERROR);
        this.isCreateNoteFromAttachmnetsInfo = true;
        const activityLogKeys: ActivityLogKey[] = [{
          key: MemberActivityLogType.Attachment,
          value: fileName + ' failed to download'
        }];
        if (this.memberId) {
          this._commonService.saveMemberActivity(this.memberId, activityLogKeys).subscribe();
        }
      });
    } else {
      this._customerService.downloadDocument(url, fileName).subscribe(blob => {
        this.saveFile(blob,fileName);
      });
    }
  }

saveFile(blob: Blob , fileName: string) {
  importedSaveAs(blob, fileName);
        let downloadNotification: any = this._translatePipe.get("Attachment  has been downloaded successfully");
        this._commonService.createNotification("", downloadNotification.value, NotificationType.SUCCESS);
        this.isCreateNoteFromAttachmnetsInfo = true;
        const activityLogKeys: ActivityLogKey[] = [{
          key: MemberActivityLogType.Attachment,
          value: fileName + ' was downloaded'
        }];
        if (this.memberId) {
          this._commonService.saveMemberActivity(this.memberId, activityLogKeys).subscribe();
        }
}

 /*Check for max of 15 attachments */
 checkMaxAttachments(){
    if(this.uploader.queue){
      this.attachmentsLength = this.uploader.queue.length;
        if (this.attachmentsLength >= 15) {
            while (this.attachmentsLength > 15) {
                this.uploader.queue[this.uploader.queue.length - 1].remove();
                this.attachmentsLength--;
            }
        }
    }
}

/**
   * On Page change
   * @param pageNumber
   */
pageChange(pageNumber: number) {

    if (!isNaN(pageNumber)) {
        this.pageNumber = pageNumber;
        this.isDesc = false;
        this.getAttachments();
    }
}

    /*
     *Saving Member Notes
    */
    saveNote(isValid: any) {
        this.isSubmitted = true;
        const invalidFields:any =  document.querySelectorAll('#Create-Note-js .ng-invalid');
        window.scrollTo(this.elementoffsetValue,0)
        if(invalidFields[0]){
            invalidFields[0].focus();
        }
        let  notesDescription  =  this.createNotesForm.controls['notesDescription'].value.trim();
	    let  notesSummary  =  this.createNotesForm.controls['notesSummary'].value.trim();
	    if  (isValid  &&  notesDescription  !== ""  &&  notesSummary  !==  "") {
            this.isSubmitted = false;
            let notesData = {
                "noteTypeID": this.createNotesForm.controls['notesType'].value,
                "description": this.createNotesForm.controls['notesDescription'].value.trim(),
                "summary": this.createNotesForm.controls['notesSummary'].value.trim(),
                "createdByUserId": this.userInfo.userId,
                "createdByUserName": this.userInfo.userName,
                "createdDate": new Date(),
                "memberId": this.fboProfileDetail.id ? this.fboProfileDetail.id : null,
                "distributorId": this._id,
            }

            this._customerservice.saveNoteAtMemberLevel(notesData).subscribe((response) => {
                if (response.isSuccess) {
                    let notesResponse = response;
                    let addedNotification: any;
                    if(!this.isCreateNoteFromAttachmnetsInfo){
                        addedNotification = this._translatePipe.get("Note has been Added successfully");
                    }
                    else{
                        addedNotification = this._translatePipe.get("Note has been Added with Attachment information successfully");
                    }
                    this._commonService.createNotification("", addedNotification.value , NotificationType.SUCCESS);
                    this.getMemberNotes();
                    const activityLogKeys: ActivityLogKey[] = [{
                        key: MemberActivityLogType.Note,
                        value: ''
                      }];
                    if (this.memberId) {
                        this._commonService.saveMemberActivity(this.memberId, activityLogKeys).subscribe();
                    }
                }
                else {
                    this._commonService.createNotification("", "Note creation has been failed", NotificationType.ERROR);
                }
            });
            this.createNotesPopup.close();
            // this._commonService.jumpingScroll(false);
        }
        else{
            this._commonService.createNotification("", "Invalid Data", NotificationType.ERROR);
        }
    }

/*
  * get Member Notes based on Member Id or DistributorID
*/
    getMemberNotes() {
        if (this._id) {
            let fileDetails = {
                "distributorId": this._id,
                "memberId": null,
                "typeId": null,
                "startDate": "",
                "endDate": "",
                "pageSize": this.pageSize,
                "pageNumber": this.memberNotesPageNumber,
                "sort": this.memberNotesSortOrder ? "ASC" : "DESC",
                "elements": [this.sortOrder]
            }
            this._customerservice.getMemberNotes(fileDetails).subscribe(response => {
                if (response) {
                    this.memberNotesInfo = [];
                    this.memberNotesInfo = response.content;
                    if (this.memberNotesInfo && this.memberNotesInfo.length > 0) {
                        this.memberNotesInfo.forEach(x => {
                            if (x && x.createdDate) {
                                x.monthDateFormat = moment.utc(x.createdDate)
                                .utcOffset(this.storeInfo.timeZoneOffset * 60).format('DD-MMM-YYYY');
                                x.hoursDateFormat = moment.utc(x.createdDate)
                                .utcOffset(this.storeInfo.timeZoneOffset * 60).format('h:mm a');
                            }
                        });
                    }
                    this.memberNotesPageNumber = response.pageNumber + 1;
                    this.memberNotesPageCount = response.totalCount;
                }
            });
        }
    }

    /*
     * Sort member notes grid
    */
     sortMemberNotes(sortOrder:string){
         if(this.memberNotesSortOrder === true){
            this.memberNotesSortOrder= false;
         }
         else{
            this.memberNotesSortOrder = true;
        }
        this.sortOrder = sortOrder;
        this.getMemberNotes();
    }

    /**
   * On Page change of member notes
   * @param pageNumber
   */
    memberNotesPageChange(pageNumber: number) {
        if (!isNaN(pageNumber)) {
            this.memberNotesPageNumber = pageNumber;
            this.memberNotesSortOrder = false;
            this.getMemberNotes();
        }
    }





 }



// WEBPACK FOOTER //
// ./src/app/customerservice/components/member-notes.component.ts